import createAdapter from './createAdapter'
import {
  setSessionItem,
  getSessionItem,
  removeSessionItem,
} from '../../storeManager'

export const zemanta = createAdapter(() => true, {
  track(eventName) {
    const postbackid = getSessionItem('postbackid')
    const img = document.createElement('img')
    let url

    switch (eventName) {
      case 'Purchase':
        url = 'https://p1.zemanta.com/p/2998/3305/'
        break
      case 'Install':
        url = 'https://p1.zemanta.com/p/2998/3303/'
        break
      default:
        return
    }

    img.setAttribute('src', `${url}?postbackid=${postbackid}`)
    img.addEventListener('load', () => removeSessionItem('postbackid'))
    document.getElementsByTagName('body')[0].appendChild(img)
  },
  saveId() {
    const postbackid = new URLSearchParams(document.location.search).get(
      'postbackid'
    )
    if (postbackid) setSessionItem('postbackid', postbackid)
  },
})
